import { toast } from "@/components/ui";
import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type { AiFeedItem } from "./types";

export interface RejectAiFeedItemResponse {
  aiFeedItem: AiFeedItem;
}

interface RejectAiFeedItemVariables {
  itemId: number;
}

export const useRejectAiFeedItem = (
  patientId: string,
  encounterId: string,
  itemId: number,
) => {
  const queryClient = useQueryClient();

  return useApiMutation<RejectAiFeedItemResponse, RejectAiFeedItemVariables>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.AiFeed.REJECT(
        patientId,
        encounterId,
        itemId,
      ),
      mutationFn: async ({ itemId: mutationItemId }) => {
        const response = await axiosInstance.post<RejectAiFeedItemResponse>(
          `/charting/ai-feed/items/${mutationItemId}/reject`,
        );
        return response.data;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.AiFeed.DEFAULT(
            patientId,
            encounterId,
          ),
        });
      },
      onError: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.AiFeed.DEFAULT(
            patientId,
            encounterId,
          ),
        });
        toast.error(
          "Something went wrong dismissing an AI Feed item. Please try again.",
        );
      },
    },
  });
};
